import comp from "./SuggestedPromptsSidebar";
export default comp;
